/* eslint-disable */
'use strict'
import _ from 'lodash'
import { emailed, buildDestinatario, buildOggetto } from './emailed.js'
import xml7 from '@/services/xml7Service.js'
import elettronica from '@/services/elettronicaService.js'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import emailService from '@/services/emailService.js'
import reporting from '@/services/reportingService.js'

/* 
process.on('message', async (message) => {
  const { msg, payload } = message
  if (msg == 'START') {
    console.log('Avvio Thread invio xml')
    const item = payload
    console.log('Child process received START message')
    await salvataggioAvvenuto(item)
    console.log('Thread complete')
  }
}); */
var infoEmail, infoFatturazione

const salvataggioAvvenuto = async (item, router) => {
  const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
  infoEmail = _.get(impostazioni, 'email')
  infoFatturazione = _.get(impostazioni, 'fatturazione')
  if (abilitaInvioSDI(item)) {
    if (xmlTrasferito(item)) return
    const xmlResult = await xml7.creaXml7Multipli([item._id])
    if (xmlResult.length > 0) {
      const ft = xmlResult[0]
      const result = await elettronica.trasferisciXml(item._id, ft.file, ft.link)
    }
  }
  if (abilitaInvioEmail(item, true)) {
    if (!giaInviata(item)) {
      await emailDocumento(item, router)
    }
  }        
}

const abilitaInvioEmail = (item, verificaAutomatico) => {
  if (!infoEmail) return false
  const info = infoEmail.find(x => x.tipiDocumento.includes(item.tipoDocumento.tipoDocumento))
  if (!verificaAutomatico) {
    return info ? info.abilitaInvioEmail : false
  } else {
    return info ? info.abilitaInvioEmail && info.invioAutomatico : false
  }
}

const abilitaInvioSDI = (item) => {
  if (!infoFatturazione) return false
  if (infoFatturazione.tipiDocumento.includes(item.tipoDocumento.tipoDocumento)) {
    return infoFatturazione ? infoFatturazione.invioAutomaticoSDI : false
  } else {
    return false
  }
}

const xmlTrasferito = (item) => {
  return _.get(item, 'tipoDocumento.xml.fileTrasferito', false)
}

const giaInviata = (item) => {
  const em = _.get(item, 'editInfo.emailed')
  return em && em.length > 0 
}

const emailDocumento = async (item, router) => {
  try {
    let info = infoEmail.find(x => x.tipiDocumento.includes(item.tipoDocumento.tipoDocumento))
    if (!info) return
    const tipoDestinatario = info.emailInvio || 'pec'
    const tipoCc = info.emailCc || ''  
    
    const cliente = await clienti.getCliente(item.anagrafica.cliente.codice)
    const destinatario = buildDestinatario(cliente, tipoDestinatario)
    if (destinatario.length === 0) {         
      return {
        errorTitle: 'Invio email non possible !',
        errorMessage: 'Non è stata trovata una email valida per il destinatario.<br />Valore cercato: ' + tipoDestinatario,
        dialogErrore:true
      }
    }
    const result = await reporting.stampaDocumento(router, item, true, true, null, 'base64')
    if (result && result.error) {           
      return {
        errorTitle: 'Invio email non possible !',
        errorMessage: 'Errore nella stampa del documento',
        dialogErrore:true
      }
    } else {
      const copiaCarbone = buildDestinatario(cliente, tipoCc)
      const allegati = [{
        content: result,
        filename: 'documento.pdf',
        type: 'application/pdf',
        disposition: 'attachment'
      }]
      info.oggetto = buildOggetto(item, info.oggetto)
      if (await emailService.inviaEmail(destinatario, copiaCarbone, info, allegati)) {
        await emailed(item._id, destinatario, copiaCarbone)
      }
    }
  } catch(err) {
    console.log('errore', err)
  }
}

export default {
  salvataggioAvvenuto
}
